import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Subject } from 'rxjs/Subject';

import { ApiClient } from '../api-client';
import { User } from './user';
import { SessionService } from '../session.service';

@Injectable()
export class UserService extends ApiClient {
  store: Subject<User[]>;
  path = '/users';

  constructor(protected http: Http, protected session: SessionService) {
    super(http);
    this.store = <Subject<User[]>>new Subject();
  }
}



// WEBPACK FOOTER //
// ./src/app/api/resources/user.service.ts